module.exports = __webpack_public_path__ + "slide2-environments.08acf8adb41142fea743c658d89a7515.hashedasset.svg";